import AOPFieldVisibilityToggle from "@/src/components/AdmissionsOfficePage/shared/AOPFieldVisibilityToggle/AOPFieldVisibilityToggle";
import { Control, Controller, Path, FieldValues } from "react-hook-form";

interface MaltaFullTimeFeeFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  visibilityName: Path<T>;
  label: string;
  inputClassName: string;
  inputId: string;
}

const MaltaFullTimeFeeField = <T extends FieldValues>({
  control,
  name,
  visibilityName,
  label,
  inputClassName,
  inputId,
}: MaltaFullTimeFeeFieldProps<T>) => (
  <div className="form-group-fields-input has-visibility-toggle">
    <div className="form-group-fields-input-label">
      <label htmlFor={inputId}>{label}</label>
      <div className="form-group-fields-input-label-line"></div>
    </div>
    <Controller
      name={name}
      control={control}
      render={({ field }) => <input className={inputClassName} id={inputId} type="text" {...field} value={field.value ?? ""} />}
    />
    <div className="form-group-fields-input-svg">
      <Controller
        name={visibilityName}
        control={control}
        render={({ field }) => (
          <AOPFieldVisibilityToggle visible={!!field.value} onChange={field.onChange} ariaLabel={`${label} visibility`} />
        )}
      />
    </div>
  </div>
);

export default MaltaFullTimeFeeField;
